import L from "leaflet";

L.SensorIcon = L.DivIcon.extend({
  setColor: function(color) {
    this.dom.style.backgroundColor  = color;
  },
  createIcon: function() {
    var div = document.createElement("div");
    div.style.display = 'block';
    div.style.position = 'absolute';
    div.style.width =  '25px';
    div.style.height = '25px';
    div.style.borderRadius = '15px';
    div.style.backgroundColor  = this.options.color;

    var img = document.createElement('img');
    img.src = '/img/czujnik_powietrza.png';
    img.width = "21";
    img.height = "21";

    div.appendChild(img);
    
    this.dom = div;
    this._setIconStyles(this.dom, 'div');

    return this.dom;
  }
});

L.sensorIcon = function(options) {
  return new L.SensorIcon(options);
};


